
import { gsap } from "gsap";



(function($) { "use strict";

	const stickers = $('.sticker');
	stickers.each(function(){
		const sticker = this;
		const container = $(this).closest('.sticker-container').get(0);

		//set sticker disappear
		gsap.set(sticker, { scale: 0, xPercent: -50, yPercent: -10 });

		//on enter, make sticker big and opaque
		container.addEventListener("pointerenter", function(e) {
			gsap.to(sticker, 0.3, { scale: 1, opacity: 1 });
			positionSticker(e);
		});

		//on leave get sticker small/transparent
		container.addEventListener("pointerleave", function(e) {
			gsap.to(sticker, 0.3, { scale: 0, opacity: 0 });
			positionSticker(e);
		});

		//move sticker along
		container.addEventListener("pointermove", function(e) {
			positionSticker(e);
			//console.log('container entered');
		});


		const positionSticker = function(e) {
			// console.log('moving', $(sticker).parent().attr('class'))

			// const relX = e.pageX - getOffsetLeft(container);
			// const relY = e.pageY - getOffsetTop(container);

			const relX = e.pageX - $(container).offset().left;
			const relY = e.pageY - $(container).offset().top;

			// console.log('container: ', container, 'event', e);
			// console.log('e.pageX', e.pageX,  "e.pageY", e.pageY, "container.offsetLeft", container.offsetLeft, "container.offsetTop", container.offsetTop,'getOffsetTop(container)', getOffsetTop(container), '$(container).offset().top', $(container).offset().top,  'relX', relX, 'relY', relY );

			const old_relX = sticker.getAttribute('relX');

			sticker.setAttribute('relX', relX);

			if (relX - old_relX > 5) {
				//moving right. tilt clockwise
				gsap.to(sticker, {
					rotation:12,
					duration:0.3,
					ease:'none',
				})
			} else if (relX - old_relX < - 5) {
				//moving left. tilt counterclockwise
				gsap.to(sticker, {
					rotation:-12,
					duration:0.3,
					ease:'none',
				})
			} else {
				//upright
				gsap.to(sticker, {
					rotation:0,
					duration:0.3,
					ease:'none',
				})
			}
			
			gsap.to(sticker, { duration: 1.25, ease: "expo.out", x: relX, y: relY});
		}

	});

	$('.hero-slide-piano__content, .section-hero-slider-piano__paging')
		.on('mouseover', function() {
			$(this).closest('.sticker-container').find('.sticker').each(function(){
				gsap.to(this, 0.3, {scale: 0, opacity: 0});
			});
		})
		.on('mouseout', function() {
			$(this).closest('.sticker-container').find('.sticker').each(function(){
				gsap.to(this, 0.3, {scale: 1, opacity: 1});
			});
		})
	;
})(jQuery);









